module.exports = __webpack_public_path__ + "static/black-box-bg-54c12aa7e6bda6281d934dfe6c3b4bcf.jpg";